import {IRouletteBet} from "./IRouletteBet";

export class LineBet implements IRouletteBet {
    constructor(public index: number, public betAmount: number) {

    }
}



// WEBPACK FOOTER //
// ./src/app/betTypes/LineBet.ts